<script setup lang="ts">
defineOptions({
	name: 'IconPlayStation',
})

interface Props {
	class?: string
	classIcon?: string
}

const props = withDefaults(defineProps<Props>(), {
	class: 'text-neutral-50',
	classIcon: 'w-8 h-8',
})
</script>

<template>
	<svg
		:class="[props.class, props.classIcon]"
		viewBox="0 0 24 26"
		xmlns="http://www.w3.org/2000/svg"
	>
		<path
			d="M6.86914 4.11212C7.93845 3.74084 9.1061 3.82728 10.1143 4.35236L10.6064 4.60919C10.641 4.62716 10.6791 4.6365 10.7178 4.63654H13.2822C13.321 4.63653 13.3598 4.62728 13.3945 4.60919L13.8867 4.35236C14.8947 3.82748 16.0618 3.74105 17.1309 4.11212L17.7822 4.33868C19.1599 4.81716 20.2077 5.99528 20.5605 7.46271L22.5479 15.7264C22.791 16.7373 22.8154 17.7923 22.6191 18.8143L22.4932 19.4686C22.3501 20.2135 21.9291 20.8694 21.3223 21.2908L20.5771 21.8084C19.9151 22.2682 19.0381 22.2048 18.4434 21.6541L14.8047 18.285C14.759 18.2426 14.6998 18.2186 14.6387 18.2186H9.3623C9.30108 18.2186 9.24205 18.2426 9.19629 18.285L5.55664 21.6541C4.96194 22.2046 4.08587 22.2681 3.42383 21.8084L2.67871 21.2908C2.07198 20.8695 1.64995 20.2143 1.50684 19.4695L1.38184 18.8143C1.18561 17.7923 1.20903 16.7373 1.45215 15.7264L3.43945 7.46271C3.79238 5.99516 4.8409 4.81709 6.21875 4.33868L6.86914 4.11212ZM16.6572 5.59454C15.9653 5.35431 15.21 5.41104 14.5576 5.75079L14.0654 6.00665C13.8224 6.13322 13.5539 6.19903 13.2822 6.19904H10.7178C10.4462 6.199 10.1784 6.13313 9.93555 6.00665L9.44336 5.75079C8.79106 5.41106 8.03563 5.35435 7.34375 5.59454L6.69336 5.82111C5.80181 6.13066 5.12289 6.893 4.89453 7.84259L2.90723 16.1063C2.71815 16.8925 2.69995 17.7128 2.85254 18.5076L2.97754 19.1629C3.04259 19.5014 3.23493 19.7995 3.51074 19.991L4.25586 20.5086C4.35042 20.5741 4.47564 20.5648 4.56055 20.4861L8.19922 17.117C8.51956 16.8204 8.9337 16.6561 9.3623 16.6561H14.6387C15.0671 16.6561 15.4805 16.8205 15.8008 17.117L19.4404 20.4861C19.5254 20.5647 19.6506 20.5743 19.7451 20.5086L20.4902 19.991C20.766 19.7995 20.9574 19.5014 21.0225 19.1629L21.1484 18.5076C21.301 17.7128 21.2818 16.8925 21.0928 16.1063L19.1055 7.84259C18.8771 6.89303 18.1991 6.13068 17.3076 5.82111L16.6572 5.59454Z"
			fill="currentColor"
		/>
		<path
			d="M9.5 10.6562C9.91421 10.6562 10.25 11.006 10.25 11.4375C10.25 11.833 9.96785 12.1599 9.60177 12.2116L9.5 12.2188H6.5C6.08579 12.2188 5.75 11.869 5.75 11.4375C5.75 11.042 6.03215 10.7151 6.39823 10.6634L6.5 10.6562H9.5Z"
			fill="currentColor"
		/>
		<path
			d="M8 9.09375C8.3797 9.09375 8.69349 9.38766 8.74315 9.76899L8.75 9.875V13C8.75 13.4315 8.41421 13.7812 8 13.7812C7.6203 13.7812 7.30651 13.4873 7.25685 13.106L7.25 13V9.875C7.25 9.44353 7.58579 9.09375 8 9.09375Z"
			fill="currentColor"
		/>
		<path
			d="M15.4987 12.2477C15.7644 12.2473 16.0192 12.3571 16.2071 12.5528C16.3636 12.7158 16.4629 12.9274 16.4915 13.1535L16.5 13.2906C16.4993 13.8656 16.0516 14.3312 15.4996 14.331C14.9476 14.3308 14.5002 13.8648 14.5 13.2898C14.4998 12.7149 14.9468 12.2484 15.4987 12.2477Z"
			fill="currentColor"
		/>
		<path
			d="M15.4987 8.54401C15.7644 8.54365 16.0192 8.65342 16.2071 8.84909C16.3636 9.01215 16.4629 9.22369 16.4915 9.44981L16.5 9.58697C16.4993 10.1619 16.0516 10.6276 15.4996 10.6273C14.9476 10.6271 14.5002 10.1611 14.5 9.58613C14.4998 9.01118 14.9468 8.54474 15.4987 8.54401Z"
			fill="currentColor"
		/>
		<path
			d="M17.2786 10.3963L17.3952 10.4035C17.8922 10.4642 18.2776 10.9045 18.2773 11.4384C18.2771 12.0134 17.8297 12.4794 17.2777 12.4796C16.7258 12.4799 16.278 12.0142 16.2773 11.4393C16.277 11.1625 16.3824 10.8971 16.5703 10.7014C16.7268 10.5383 16.9299 10.4349 17.147 10.4052L17.2786 10.3963Z"
			fill="currentColor"
		/>
		<path
			d="M13.7239 10.3954L13.8404 10.4025C14.3374 10.4633 14.7229 10.9036 14.7227 11.4375C14.7224 12.0124 14.275 12.4785 13.7231 12.4787C13.1711 12.479 12.7233 12.0133 12.7227 11.4383C12.7223 11.1616 12.8277 10.8961 13.0155 10.7005C13.1721 10.5374 13.3752 10.434 13.5922 10.4043L13.7239 10.3954Z"
			fill="currentColor"
		/>
	</svg>
</template>
